export enum ActionTypes {
 GET_EQUIPMENT = '[GET_EQUIPMENT] Get equipment',
 GET_EQUIPMENT_SUCCESS = '[GET_EQUIPMENT] Get equipment success',
 GET_EQUIPMENT_FAILURE = '[GET_EQUIPMENT] Get equipment failure',
}
